<div class="containar-layout availability-grid">
  <div class="ui-g-12 availability-container" id="availability-container-id">
    <div class="ui-g-12 availability-timeslot-inner">
      <div class="provider-timeslot-head"> Team Member ({{fromDate | date:'dd MMM' }})
      </div>
      <div class="availability-timeslot-card" *ngFor="let timeSlot of timeslots; let timeIndex = index;">
        <div>{{timeSlot.lable}}</div>
      </div>
    </div>
    <div class="ui-g-12" *ngIf="providerFinalResponse == null || providerFinalResponse.length === 0 ">
      <div class="ui-g-12 info-lable" style="text-align: center;" translate>label_no_records_available</div>
    </div>
    <div class="availability-inner" *ngFor="let provObj of providerFinalResponse; let curIndex = index;">
      <div class="provider-head">
       <span class="witeSpace">{{provObj.firstName}} {{provObj.lastName}}<span class="rolename" *ngIf="showRole">  ({{ provObj.roleName }})</span></span>
        <div class="provider-head-sublable">
          <div class="btn-wrapper">
            <div class="shift-txt-break" tooltipStyleClass="notes-tooltip" *ngIf="provObj?.notes" [escape]="false"
              pTooltip="<div class='tooltip-wrapper'><h5>Notes</h5> {{provObj?.notes}} </div>" tooltipPosition="bottom"
              placeholder="Bottom">
              <div class="icon"><img src="/assets/images/temp/note.svg" alt="note icon" /></div>
            </div>
            <div class="icon" (click)="editSlot(provObj)" *ngIf="!provObj?.fullDayOff && !isPastDate && ((!showRole && !isOrgLevelDOO  && !providerArr.includes(provObj?.providerId) && !teamDutyOOArr.includes(provObj.memberSchedules[0]?.userTeams[0]?.teamId)) || showRole)"><img
                src="/assets/images/temp/edit_availability.svg" alt="edit icon" /></div>
            <div class="icon" (click)="addTimeOff(provObj)" *ngIf="!provObj?.leaveType && !isPastDate && isPTOEnable"><img
                src="/assets/images/temp/add_time_off.svg" alt="add timeoff icon" /></div>
            <div class="icon" (click)="confirmCancelLeave(provObj)"
              *ngIf="provObj?.memberSchedules[0]?.memberStatusStr !== 'Unavailable' && provObj?.leaveType && !isPastDate && isPTOEnable">
              <img src="/assets/images/temp/cancel_leave.svg" alt="apply leave icon" /> </div>
            <div class="icon" (click)="addDeleteShift(provObj.id, provObj.providerId, provObj.firstName, provObj.lastName, provObj.userType)" *ngIf="(!showRole && !organizationLevelShift && !organizationLevelDispatch && !providerArr.includes(provObj.providerId) && !teamDutyOOArr.includes(provObj.memberSchedules[0]?.userTeams[0]?.teamId)) || showRole">
              <img src="/assets/images/temp/bulk-schedule-icon.svg" alt="Bulk schedule icon" /> </div>
          </div>
        </div>
      </div>
      <div class="availability-card q1" *ngFor="let time of provObj.timeslots15m">
        <div *ngIf="!time.available">
          <div style="background-color: #dcdcdc; height: 40px;">&nbsp;
          </div>
        </div>
        <div *ngIf="time.available">
          <div style="height: 40px; cursor: pointer;"
            [ngStyle]="{'background-color': time.available === 'available' ? '#7DD5AB' : '#F7D3D3'}">&nbsp;
            <div class="a-tooltip">&nbsp;
              <span class="tooltiptext" [innerHTML]="time.slotTimeStr">
                </span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="((curIndex +1) < providerFinalResponse.length)">
        <div *ngIf="(providerFinalResponse[(curIndex +1)].teamId) != provObj.teamId">
          <br>
        </div>
      </div>

    </div>
  </div>
  
<!-- Mobile responsive team member day view -->
  <div class="availability-container-mobile">
    <div class="header-wrapper">
      <h2 class="heading">{{fromDate | date:'dd MMM YYYY' }}</h2>
      <div class="slot-wrapper" *ngFor="let provObj of providerFinalResponse; let curIndex = index;">
        <app-team-member-day-slot-card [memberSchedules]="provObj" [isPastDate]="isPastDate"
        (cancelLeaveEmiiter)="confirmCancelLeave(provObj)" (editSlotEmitter)="editSlot(provObj)"
        (addTimeOffEmitter)="addTimeOff(provObj)"></app-team-member-day-slot-card>
      </div>
    </div>
  </div>

  <p-dialog [blockScroll]="true" modal="true" [showHeader]="false" position="center" responsive="true"
    styleClass="medium-popup" [(visible)]="showAddTimeOffPopup" responsive="true" ng-style="overflow: auto"
    [contentStyle]="{'overflow':'auto'}">
    <app-add-time-off-modal *ngIf="showAddTimeOffPopup" (closeAddTimeOffEmitter)="closeAddTimeOffPopup($event)"
      [addTimeOffDetails]="addTimeOffDetails"></app-add-time-off-modal>
  </p-dialog>

  <p-dialog class="manage-pop-shift" [blockScroll]="true" modal="true" [showHeader]="false" position="center"
    responsive="true" [style]="{width: '650px', height: 'auto', 'max-width': '90%'}" styleClass="add-routes-popup"
    [(visible)]="showEditPopup" responsive="true" ng-style="overflow: auto" [contentStyle]="{'overflow':'auto'}">
    <app-manage-shift-details *ngIf="showEditPopup" (publishOpenShiftEmitter)="onClickOfPopupButton($event)"
      [shiftDetails]="editSlotDetails"></app-manage-shift-details>
  </p-dialog>

  <p-confirmDialog styleClass="medium-popup" [acceptLabel]="'Yes'" [rejectLabel]="'No'">
  </p-confirmDialog>
